// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputContainerTopWrapper {
    /* border-bottom: 1px solid black; */
    background-color: var(--InputContainerBackground);
    border-radius: 5px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding: 12px;
    padding-bottom: 8px;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}

.InputContainerTopMessage {
    display: block;
    text-align: center;
    color: var(--InputContainerMessageColor);
    min-width: 20px;
    min-height: 20px;
    margin: 4px 20px;
}

.InputContainerContentWrapper {
    position: relative;
    top: 0px;
    bottom: -20px;
    min-width: 0px;
    padding: 2px;
    padding-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    scroll-behavior: smooth;
}

.InputContainerContentAndTopWrapper {
    min-height: 0px;
    max-height: 100%;
    border-radius: 10px;
}

@media only screen and (max-width: 830px) {
    .InputContainerContentWrapper {
        max-height: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/InputContainer/InputContainer.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".InputContainerTopWrapper {\n    /* border-bottom: 1px solid black; */\n    background-color: var(--InputContainerBackground);\n    border-radius: 5px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 12px;\n    padding-bottom: 8px;\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n\n.InputContainerTopMessage {\n    display: block;\n    text-align: center;\n    color: var(--InputContainerMessageColor);\n    min-width: 20px;\n    min-height: 20px;\n    margin: 4px 20px;\n}\n\n.InputContainerContentWrapper {\n    position: relative;\n    top: 0px;\n    bottom: -20px;\n    min-width: 0px;\n    padding: 2px;\n    padding-top: 0px;\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    scroll-behavior: smooth;\n}\n\n.InputContainerContentAndTopWrapper {\n    min-height: 0px;\n    max-height: 100%;\n    border-radius: 10px;\n}\n\n@media only screen and (max-width: 830px) {\n    .InputContainerContentWrapper {\n        max-height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
